<div class="ya-bottomsheet-container ya-typography">
  <ya-bottomsheetclosebottom [bottomSheetRef]="bottomSheetRef"></ya-bottomsheetclosebottom>
  <div class="ya-bottomsheet-content-center">
    <h2>
      <span langkey="phLanguageDialog_Title"></span>
    </h2>
    <div class="ya-dialog-content">
      <div id="languageList" #languageListView class="language-dialog-list">
        <ng-container *ngFor="let language of languages; let i = index">
          <a a11y_Button matRipple matRippleCentered="true" (click)="setLanguage(language)">
            <div class="language-dialog-item">
              <div class="language-item-content">
                <h3>
                  <span langkey="phLanguageDialog_lang_{{language}}"></span>
                </h3>
              </div>
              <div class="language-symbol">
                <div class="inline-icon ya-favorite-svg ya-round-svg"
                  [inlineSVG]="'shop-icons.svg#ya-flag-' + (language || 'de')">
                </div>
              </div>
            </div>
          </a>
        </ng-container>
      </div>
    </div>
  </div>
</div>